import React from "react";
import { Skeleton } from "@mui/material";
import Grid from '@mui/material/Grid2';

const OrgDashSkeleton = () => {

    return (
        <Grid container spacing={2} justifyContent="center" style={{width:"100%"}}>
            <Grid item size={{xs:8,md:6}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={280}
                    animation="wave"
                    style={{borderRadius:16,marginBottom:10}}
                />
            </Grid>
            <Grid item size={{xs:12}}>
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    animation="wave"
                    height={70}
                    style={{borderRadius:16,marginBottom:10}}
                />
            </Grid>
        </Grid>

    );
};

export default OrgDashSkeleton;
